const B_1 = [
    {
        title: '招标项目',
        path: '/bidding/zbproject/list'
    }
]

export default {
    path: '',
    component: () => import(/*webpackChunkName: 'zb-project'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/zb-project/list'),
            meta: {
                title: '招标项目列表',
                topNav: true,
                bread: B_1
            },
        }
    ]
}
